export const MESSAGES_ALERT = Object.freeze({
	ALERT: 'A continuación se muestra en detalle las incosistencias detectadas en tu documento.',
});
